<template>
  <div class="banner">
    <img src="../../public/image/banner2.png" alt />
    <div class="text">
      <p class="title" :class="{ fadeinup: fadeinup }">
        {{ $t("home").about.text1 }}
      </p>
      <p
        class="con"
        :class="{ fadeinup2: fadeinup, en_con: $i18n.locale == 'en' }"
        data-scrollbar
      >
        {{ $t("home").about.text2[0] }}
        <br />{{ $t("home").about.text2[1] }} <br />{{
          $t("home").about.text2[2]
        }}
      </p>
      <span
        class="btn"
        :class="{ fadeinup3: fadeinup }"
        style="animation-delay: 0.2s"
        @click="gotoAbout"
        >{{ $t("home").about.btn }}</span
      >
      <div class="allNums" :class="{en_allNums:$i18n.locale=='en'}" ref="counts">
        <div class="item">
          <div class="pic">
            <img src="../asset/aike/country1.png" alt="" />
          </div>
          <p class="t2"><span id="num1">20</span><span class="plus">+</span></p>
          <p class="t3">{{ $t("about").intro.allNums[0] }}</p>
        </div>
        <div class="item">
          <div class="pic">
            <img src="../asset/aike/company1.png" alt="" />
          </div>
          <p class="t2"><span id="num2"></span><span class="plus">家</span></p>
          <p class="t3">{{ $t("about").intro.allNums[1] }}</p>
        </div>
        <div class="item">
          <div class="pic">
            <img
              v-if="$i18n.locale == 'en'"
              src="../asset/aike/wealth2.png"
              alt=""
            />
            <img v-else src="../asset/aike/wealth1.png" alt="" />
          </div>
          <p class="t2">
            <span id="num3">120</span><span class="plus">+</span
            ><span class="yi">{{ $t("about").intro.allNums[3] }}</span>
          </p>
          <p class="t3">{{ $t("about").intro.allNums[2] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { CountUp } from "countup.js";
import { mapState } from "vuex";
import Scrollbar from "smooth-scrollbar";
export default {
  name: "banner",
  data() {
    return {
      hasplay: false,
      fadeinup: false,
    };
  },
  components: {},
  mounted() {
    Scrollbar.initAll();
  },
  computed: {
    ...mapState(["shortMenu"]),
    ...mapState(["readfullpage"]),
  },
  watch: {
    shortMenu(val) {
      if (val == "1" && !this.hasplay) {
        this.fadeinup = true;
        this.hasplay = true;
        this.count();
      }
    },
    readfullpage(val) {
      if (val) {
        // console.log('readfullpage')
        // this.wow = new WOW();
        // this.wow.init();
      }
    },
  },
  methods: {
    gotoAbout() {
      window.open("/about.html", "_self");
    },
    count() {
      let num1 = new CountUp("num1", 130);
      let num2 = new CountUp("num2", 49);
      let num3
      if (this.$i18n.locale == "en") {
        num3 = new CountUp("num3", 200);
      } else {
        num3 = new CountUp("num3", 25);
      }

      num1.start();
      num2.start();
      num3.start();
    },
  },
};
</script>

<style lang="scss" scoped>

.banner {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    z-index: 1;
    cursor: pointer;
    transform: scale(1);
    transition: all 5s;
  }
  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .title {
      font-size: 60px;
      font-family: "SOURCEHANSANSCN-NORMAL";
      font-weight: 600;
      color: #ffffff;
      line-height: 80px;
      text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.15);
    }
    .fadeinup {
      animation: fadeInUp 2000ms;
    }
    .fadeinup2 {
      animation: fadeInUp2 2000ms;
    }
    .fadeinup3 {
      animation: fadeInUp2 2000ms;
    }
    .con {
      width: 100%;
      color: white;
      font-size: 16px;
      font-family: "SOURCEHANSANSCN-NORMAL";
      line-height: 40px;
      text-align: center;
      font-weight: 400;
      margin: 40px auto 50px auto;
      text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.15);
      overflow: hidden;
    }
    .en_con {
      width: 75%;
      text-align: left;
    }
    .btn {
      padding: 10px 77px;
      color: white;
      text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
      background-color: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.5);
      // line-height: 48px;
      font-size: 16px;
      font-family: "SOURCEHANSANSCN-LIGHT";
      box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.15);
      cursor: pointer;
      position: relative;
      transition: all 600ms;
      &::after {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        content: "";
        background-color: #ffffffa6;
        width: 0;
        height: 100%;
        transition: all 600ms;
        z-index: -1;
      }
      &:hover {
        color: #333333;
        &::after {
          width: 100%;
        }
      }
    }
    .allNums {
      display: flex;
      // flex-direction: column;
      align-items: center;
      width: 50%;
      height: 100%;
      justify-content: space-between;
      margin-top: 160px;
      .item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .pic {
          img {
            transition: all 600ms;
            cursor: pointer;
            &:hover {
              transform: rotateY(360deg);
            }
          }
        }
        .t2 {
          font-size: 20px;
          font-family: "ITCAvantGardeStd-Bold";
          font-weight: bolder;
          color: white;
          line-height: 100px;
          height: 50px;
          line-height: 50px;
          margin: 15px 0;
          .plus {
            margin-top: -20px;
            font-size: 35px;
          }
          .yi {
            font-size: 35px;
          }
          span {
            font-size: 50px;
          }
        }
        .t3 {
          color: #d0d0d0;
          font-family: "SOURCEHANSANSCN-NORMAL";
          white-space: nowrap;
        }
      }
      .item:nth-child(2) {
        width: 40%;
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-width: 0 1px 0 1px;
      }
      // .item:nth-child(3){
      //   align-items: flex-end;
      // }
    }

    // .numBox {
    //   width: 50%;
    //   margin-top: 170px;
    //   ul {
    //     width: 100%;
    //     display: flex;
    //     align-items: center;
    //     justify-content: space-between;
    //     li {
    //       list-style: none;
    //       width: 33.3%;
    //       text-align: center;
    //       .number {
    //         display: flex;
    //         align-items: start;
    //         justify-content: center;
    //         span:nth-child(1) {
    //           font-size: 60px;
    //           font-weight: 400;
    //           text-shadow: 0 2px 2px #00000070;
    //           color: white;

    //           font-family: "DINEngschriftStd";
    //         }

    //         span:nth-child(2) {
    //           margin-left: 5px;
    //           color: #d1d1d1;
    //           font-size: 20px;
    //           font-family: "SOURCEHANSANSCN-MEDIUM";
    //           text-shadow: 1px 3px 3px rgba(0, 0, 0, 0.25);
    //         }
    //       }
    //       .intro {
    //         font-size: 16px;
    //         line-height: 30px;
    //         color: #d0d0d0;
    //         font-weight: 400;
    //         font-family: "SOURCEHANSANSCN-NORMAL";
    //         text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.5);
    //       }
    //     }
    //     li:nth-child(1),
    //     li:nth-child(2) {
    //       border-right: 1px solid #d0d0d0;
    //     }
    //   }
    // }
  }
  @keyframes fadeInUp {
    from {
      transform: translateY(100px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes fadeInUp2 {
    from {
      transform: translateY(300px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes fadeInUp3 {
    from {
      transform: translateY(500px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
@media screen and (max-width: 1000px) {
  .banner {
    .text {
      .title {
        font-size: 20px;
        line-height: 30px;
        text-align: center;
      }
      .con {
        height: 200px;
        margin-top: 10px;
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 20px;
        width: 88%;
        text-align: left;
      }
      .numBox {
        margin-top: 20px;
        width: 100%;
        ul {
          flex-direction: column;
          li {
            width: 100%;
            .number {
              span:nth-child(1) {
                font-size: 40px;
              }
              span:nth-child(2) {
                font-size: 16px;
              }
            }
            .intro {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
      .allNums {
        width: 90%;
        margin-top: 100px;
        .item {
          width: 33.333%;
          .pic {
            img {
              width: 50%;
              margin-left: 25%;
            }
          }
          .t2 {
            font-weight: unset;
            margin: unset;
            span {
              font-size: 25px;
              font-family: "it";
              color: white;
            }
            .plus {
              font-size: 16px;
              margin-left: 5px;
            }
            .yi {
              font-size: 25px;
              font-weight: lighter;
            }
          }
          .t3 {
            font-size: 14px;
            text-align: center;
            height: 28px;
            white-space: unset;
          }
        }
      }
      .en_allNums{
      .item{
        .t2{
          span{
            font-size: 16px;
          }
          .yi{
            font-size: 16px;
          }
        }
        .t3{
          font-size: 12px;
        }
      }
    }
    }
  }
}
</style>
<style scoped>
.banner .text .con >>> .scroll-content {
  width: 50%;
  margin: 0 auto;
}
@media screen and (max-width: 1000px) {
  .banner .text .con >>> .scroll-content {
    width: 80%;
  }
}


</style>
